module.exports = "<p>\n  campaign works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/nurture/src/app/campaign/campaign.component.html
// module id = ../../../../../src/app/campaign/campaign.component.html
// module chunks = main